<template>
<div>
  <section class="content-header">
    <h1>
      其它单项排行
      <small>学习综合项排行榜</small>
    </h1>
    <ol class="breadcrumb">
      <li><a href="#/"><i class="fa fa-dashboard"></i> Home</a></li>
      <li><a href="#/loudSpeakLearn/learnTime">学习综合项排行榜</a></li>
      <li class="active">其它单项排行</li>
    </ol>
  </section>

  <section class="content">
    <el-card class="box-card" body-style="padding-bottom:0px">
      <el-form :inline="true" :model="filters">
				<el-form-item>
          <el-select v-model="filters.customers" multiple filterable clearable placeholder="客户名称" style="width: 360px">
            <el-option
              v-for="item in customers"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
				</el-form-item>
        <el-form-item>
          <el-date-picker v-model="filters.dateRange" type="daterange" start-placeholder="开始日期"
            end-placeholder="结束日期" :picker-options="pickerOptions" :default-value="currentDate" value-format="yyyy-MM-dd">
          </el-date-picker>
				</el-form-item>
        <el-form-item v-show="$auth.check('ROLE_QOOCO')">
          <el-select v-model="filters.orgType" filterable clearable placeholder="机构类型">
            <el-option
              v-for="item in orgTypes"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" icon="el-icon-search" @click="query">查询</el-button>
				</el-form-item>
			</el-form>
      <div class="duration">
        <span class="label">当前查询时间段：</span>
        <span class="value">{{dateRange[0]}} 至 {{dateRange[1]}}</span>
      </div>
    </el-card>

    <el-card class="box-card">
      <div slot="header">
        <span class="header-text">学习积分排行</span>
      </div>
      <el-tabs v-model="scoreTabActive" type="card">
        <el-tab-pane label="平均积分" name="avg">
          <div class="echart">
            <IEcharts :option="scoreRanking" :resizable="true" :loading="loading"></IEcharts>
          </div>
        </el-tab-pane>
        <el-tab-pane label="总积分" name="total">
          <div class="echart">
            <IEcharts :option="totalscoreRanking" :resizable="true" :loading="loading"></IEcharts>
          </div>
        </el-tab-pane>
      </el-tabs>
    </el-card>

    <el-card class="box-card">
      <div slot="header">
        <span class="header-text">学习星星排行</span>
      </div>
      <el-tabs v-model="starTabActive" type="card">
        <el-tab-pane label="星星平均值" name="avg">
          <div class="echart">
            <IEcharts :option="starRanking" :resizable="true" :loading="loading"></IEcharts>
          </div>
        </el-tab-pane>
        <el-tab-pane label="星星总数" name="total">
          <div class="echart">
            <IEcharts :option="totalstarRanking" :resizable="true" :loading="loading"></IEcharts>
          </div>
        </el-tab-pane>
      </el-tabs>
    </el-card>

    <el-card class="box-card">
      <div slot="header">
        <span class="header-text">语音质量分析</span>
      </div>
      <div class="echart one-three">
        <IEcharts :option="voicePrimary" :resizable="true" :loading="loading"></IEcharts>
      </div>
      <div class="echart one-three">
        <IEcharts :option="voiceMiddle" :resizable="true" :loading="loading"></IEcharts>
      </div>
      <div class="echart one-three">
        <IEcharts :option="voiceSenior" :resizable="true" :loading="loading"></IEcharts>
      </div>
    </el-card>

    <el-card class="box-card">
      <div slot="header">
        <span class="header-text">技能分布</span>
      </div>
      <div class="echart two-three">
        <IEcharts :option="skillSpreadBL" :resizable="true" :loading="loading"></IEcharts>
      </div>
      <div class="echart one-three">
        <IEcharts :option="skillSpreadPie" :resizable="true" :loading="loading"></IEcharts>
      </div>
    </el-card>

    <el-card class="box-card">
      <div slot="header">
        <el-select v-model="filters.modeId" filterable clearable placeholder="课程选择" @change='changeCourse'>
          <el-option
            v-for="item in modeList"
            :key="item.key"
            :label="item.val"
            :value="item.key">
          </el-option>
        </el-select>
        <span class="header-text">课程分析</span>
      </div>
      <div class="echart">
        <IEcharts :option="courseRanking" :resizable="true" :loading="loading1"></IEcharts>
      </div>
    </el-card>
  </section>
</div>
</template>

<script>
import IEcharts from 'vue-echarts-v3/src/full'
import {mapGetters} from 'vuex'
import {loadLearnAndSkillData, loadModePackagesUsers} from 'api/loud-speak-learn'
import {subLabel, getLastWeek, parseTwoArray, parseValueName, withRank, extractArrsFromObj} from 'common/js/app-utils'

export default {
  computed: {
    ...mapGetters([
      'customers',
      'pickerOptions',
      'orgTypes',
      'modeList'
    ])
  },
  data () {
    return {
      scoreTabActive: 'avg',
      starTabActive: 'avg',
      currentDate: new Date(),
      dateRange: [],
      filters: {
        customers: [],
        dateRange: [],
        orgType: '',
        modeId: '0'
      },

      loading: true,
      loading1: true,
      style: {},
      scoreRanking: {
        title: {
          // text: '学习积分排行'
        },
        tooltip: {
          trigger: 'axis'
        },
        grid: {x: '20%', y: '9%', width: '70%', height: '75%'},
        xAxis: {},
        yAxis: {
          data: [],
          axisLabel: {
            rotate: -12,
            formatter: subLabel
          }
        },
        series: [{
          name: '平均积分',
          type: 'bar',
          data: []
        }],
        color: ['rgb(91,155,213)']
      },
      totalscoreRanking: {
        title: {
          // text: '学习积分排行'
        },
        tooltip: {
          trigger: 'axis'
        },
        grid: {x: '20%', y: '9%', width: '70%', height: '75%'},
        xAxis: {},
        yAxis: {
          data: [],
          axisLabel: {
            rotate: -12,
            formatter: subLabel
          }
        },
        series: [{
          name: '总积分',
          type: 'bar',
          data: []
        }],
        color: ['rgb(91,155,213)']
      },

      starRanking: {
        title: {
          // text: '学习星星排行'
        },
        tooltip: {
          trigger: 'axis'
        },
        grid: {x: '20%', y: '9%', width: '70%', height: '75%'},
        xAxis: {},
        yAxis: {
          data: [],
          axisLabel: {
            rotate: -12,
            formatter: subLabel
          }
        },
        series: [{
          name: '星星平均值',
          type: 'bar',
          data: []
        }],
        color: ['rgb(91,155,213)']
      },
      totalstarRanking: {
        title: {
          // text: '学习星星排行'
        },
        tooltip: {
          trigger: 'axis'
        },
        grid: {x: '20%', y: '9%', width: '70%', height: '75%'},
        xAxis: {},
        yAxis: {
          data: [],
          axisLabel: {
            rotate: -12,
            formatter: subLabel
          }
        },
        series: [{
          name: '星星总数',
          type: 'bar',
          data: []
        }],
        color: ['rgb(91,155,213)']
      },

      voicePrimary: {
        title: {
          text: '初级',
          left: 'center'
        },
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b} : {c} ({d}%)'
        },
        legend: {
          bottom: 10,
          left: 'center',
          data: []
        },
        series: [{
          name: '初级',
          type: 'pie',
          radius: '65%',
          center: ['50%', '50%'],
          selectedMode: 'single',
          data: [],
          color: ['rgb(91,155,213)', 'rgb(237,125,49)', 'rgb(165,165,165)', 'rgb(255,192,0)'],
          itemStyle: {
            emphasis: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: 'rgba(0, 0, 0, 0.5)'
            }
          }
        }]
      },

      voiceMiddle: {
        title: {
          text: '中级',
          left: 'center'
        },
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b} : {c} ({d}%)'
        },
        legend: {
          bottom: 10,
          left: 'center',
          data: []
        },
        series: [{
          name: '中级',
          type: 'pie',
          radius: '65%',
          center: ['50%', '50%'],
          selectedMode: 'single',
          data: [],
          color: ['rgb(91,155,213)', 'rgb(237,125,49)', 'rgb(165,165,165)', 'rgb(255,192,0)'],
          itemStyle: {
            emphasis: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: 'rgba(0, 0, 0, 0.5)'
            }
          }
        }]
      },

      voiceSenior: {
        title: {
          text: '高级',
          left: 'center'
        },
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b} : {c} ({d}%)'
        },
        legend: {
          bottom: 10,
          left: 'center',
          data: []
        },
        series: [{
          name: '高级',
          type: 'pie',
          radius: '65%',
          center: ['50%', '50%'],
          selectedMode: 'single',
          data: [],
          color: ['rgb(91,155,213)', 'rgb(237,125,49)', 'rgb(165,165,165)', 'rgb(255,192,0)'],
          itemStyle: {
            emphasis: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: 'rgba(0, 0, 0, 0.5)'
            }
          }
        }]
      },

      skillSpreadBL: {
        title: {
          text: ''
        },
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          data: []
        },
        grid: {
          left: '3%',
          right: '14%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: []
        },
        yAxis: {
          type: 'value'
        },
        series: [
          {
            name: '技能分布',
            type: 'line',
            lineStyle: {
              normal: {
                width: 3,
                color: 'rgb(91,155,213)',
                shadowColor: 'rgba(0,0,0,0.4)',
                shadowBlur: 10,
                shadowOffsetY: 10
              }
            },
            data: [],
            color: ['rgb(91,155,213)']
          }
        ]
      },

      skillSpreadPie: {
        title: {
          text: '',
          left: 'center'
        },
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b} : {c} ({d}%)'
        },
        legend: {
          bottom: 10,
          left: 'center',
          data: []
        },
        series: [{
          name: '技能分布',
          type: 'pie',
          radius: '65%',
          center: ['50%', '50%'],
          selectedMode: 'single',
          data: [],
          color: ['rgb(91,155,213)', 'rgb(237,125,49)', 'rgb(165,165,165)', 'rgb(255,192,0)', 'rgb(68,114,196)'],
          itemStyle: {
            emphasis: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: 'rgba(0, 0, 0, 0.5)'
            }
          }
        }]
      },

      courseRanking: {
        title: {
          text: '课程学习人数排行',
          left: 'center'
        },
        tooltip: {
          trigger: 'axis'
        },
        grid: {x: '20%', y: '15%', width: '70%', height: '75%'},
        xAxis: {},
        yAxis: {
          data: [],
          axisLabel: {
            rotate: -38,
            formatter: subLabel
          }
        },
        series: [{
          name: '人数（数目）',
          type: 'bar',
          data: []
        }],
        color: ['rgb(91,155,213)']
      }
    }
  },
  components: {
    IEcharts
  },
  mounted () {
    this.query()
  },
  methods: {
    changeCourse () {
      this._loadModePackagesUsers(this.filters)
    },
    query () {
      this._showDateRange()
      this._loadLearnAndSkillData(this.filters)
      this._loadModePackagesUsers(this.filters)
    },
    _showDateRange () {
      let t = this.filters.dateRange
      if (t && t.length === 2) {
        this.dateRange = t
      } else {
        this.dateRange = getLastWeek()
      }
    },
    _loadLearnAndSkillData () {
      this.loading = true
      loadLearnAndSkillData(this.filters)
      .then((res) => {
        this.loading = false
        this.scoreRanking.yAxis.data = withRank(res.points_ranking.keys.reverse(), res.points_ranking.ranks.reverse())
        this.scoreRanking.series[0].data = res.points_ranking.values.reverse()
        // total score
        let arrs = extractArrsFromObj(res.total_points_ranking, ['name', 'value', 'ranking'])
        this.totalscoreRanking.yAxis.data = withRank(arrs.name, arrs.ranking)
        this.totalscoreRanking.series[0].data = arrs.value

        this.starRanking.yAxis.data = withRank(res.stars_ranking.keys.reverse(), res.stars_ranking.ranks.reverse())
        this.starRanking.series[0].data = res.stars_ranking.values.reverse()
        // total star
        let arrs1 = extractArrsFromObj(res.total_stars_ranking, ['name', 'value', 'ranking'])
        this.totalstarRanking.yAxis.data = withRank(arrs1.name, arrs1.ranking)
        this.totalstarRanking.series[0].data = arrs1.value

        let _asr = res.asr
        let _easyAsr = this._parseAsr(_asr.easy)
        let _mediumAsr = this._parseAsr(_asr.medium)
        let _hardAsr = this._parseAsr(_asr.hard)
        this.voicePrimary.legend.data = _easyAsr.keys
        this.voicePrimary.series[0].data = parseValueName(_easyAsr.keys, _easyAsr.values)
        this.voiceMiddle.legend.data = _mediumAsr.keys
        this.voiceMiddle.series[0].data = parseValueName(_mediumAsr.keys, _mediumAsr.values)
        this.voiceSenior.legend.data = _hardAsr.keys
        this.voiceSenior.series[0].data = parseValueName(_hardAsr.keys, _hardAsr.values)

        let _skillSpread = this._parseSkillSpread(res.skills_durs)
        this.skillSpreadBL.xAxis.data = _skillSpread.keys
        this.skillSpreadBL.series[0].data = _skillSpread.values

        this.skillSpreadPie.legend.data = _skillSpread.keys
        this.skillSpreadPie.series[0].data = parseValueName(_skillSpread.keys, _skillSpread.values)
      }, (msg) => {
        this.loading = false
        this.$message.error(msg)
      })
    },
    _loadModePackagesUsers () {
      this.loading1 = true
      loadModePackagesUsers(this.filters)
      .then((res) => {
        this.loading1 = false
        this.courseRanking.title.text = `${res['mode_name']}学习人数排行`
        let courseArr = extractArrsFromObj(res.data, ['num', 'name'])
        this.courseRanking.yAxis.data = courseArr.name
        this.courseRanking.series[0].data = courseArr.num
      }, (msg) => {
        this.loading1 = false
        this.$message.error(msg)
      })
    },

    _parseAsr (obj) {
      let map = new Map()
      map.set('excellent', '真棒')
      map.set('good', '很好')
      map.set('fair', '还不错')
      map.set('poor', '再试一次')
      return parseTwoArray(obj, map)
    },
    _parseSkillSpread (obj) {
      let map = new Map()
      map.set('speak_1', '说单词')
      map.set('dialogue_2', '说对话')
      map.set('nosub_speak_3', '无字幕对话')
      map.set('comprehension_4', '综合运用')
      map.set('spell_5', '单词拼写')
      return parseTwoArray(obj, map)
    }
  }
}
</script>


<style lang="stylus" scoped>
  @import '~common/stylus/base'
</style>



// WEBPACK FOOTER //
// src/components/loud-speak-learn/learn-and-skill.vue